import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { userCourses } from '../mockData/user-courses-data';

const UserCoursesApi = [rest.get(`${API_ROOT}user-courses`, (req, res, ctx) => res(ctx.json(userCourses)))];
export default UserCoursesApi;
